import React, { useState } from "react";
import ReactWordcloud from 'react-wordcloud';
import { Grid, Typography } from "@material-ui/core";
import { WORDS_TO_REMOVE } from '@icarius-pages/pollReview/constants';
import { SentimentGood, SentimentBad, SentimentNeutral } from "@icarius-icons"
import AmountComparison from "./amountComparison";
import SentimentDialog from "@icarius-pages/pollReview/components/questionData/sentimentDialog";
import SectionContainer from "@icarius-pages/pollReview/components/questionData/sectionContainer";
import DoughnutChart from "@icarius-pages/pollReview/components/questionData/doughnut/doughnutChart";
import { getLocalizedString } from "@icarius-localization/strings";

const WordsPollData = (props) => {

    const {
        questionData,
        sentiments,
        pollsSelectedColors,
        pollsSelected,
        forceGridDataUpdate,
    } = props;

    const [gridData, setGridData] = useState(null);

    const sentimentsData = [
        {
            icon: <SentimentBad />,
            data: [sentiments[0]['Muy Negativa'], sentiments[1]['Muy Negativa']],
        },
        {
            icon: <SentimentNeutral />,
            data: [sentiments[0]['Neutra'], sentiments[1]['Neutra']],
        },
        {
            icon: <SentimentGood />,
            data: [sentiments[0]['Muy Positiva'], sentiments[1]['Muy Positiva']],
        },
    ]

    const handleSentimentClick = (type, data1, data2) => {
        const formattedData = [
            ...data1.map((item) => ({
                ...item,
                Encuesta: pollsSelected[0].name,
            })),
            ...data2.map((item) => ({
                ...item,
                Encuesta: pollsSelected[1].name,
            }))
        ];

        setGridData({ type, data: formattedData });
    }

    const getFilteredWords = (wordsArray) => {
        return wordsArray.filter(word => {
            const formattedWord = word.toLowerCase().replace(/[^ña-zá-ú]/g, "");
            return formattedWord.length > 1 && !WORDS_TO_REMOVE.includes(formattedWord)
        });
    }

    const getWordsArray = () => {
        const answersArray = questionData.map((question) => question.RESPUESTA);
        return getFilteredWords(answersArray.reduce((prev, current) => {
            return (
                [
                    ...prev,
                    ...current.split(" ").map((answer) => answer.toLowerCase().replace(/[^a-zá-ú]/g, ""))]
            )
        }, []));
    }

    const getCountArray = () => {
        const countArray = getWordsArray().reduce((prev, current) => {
            return (prev[current] ? prev[current]++ : prev[current] = 1, prev)
        }, [])
        return countArray;
    }

    const getCloudData = () => {
        const countArray = getCountArray();
        return Object.keys(countArray).map((item, index) => {
            return (
                {
                    text: item,
                    value: Object.values(countArray)[index],
                }
            )
        }).sort((a, b) => b.value - a.value);
    }

    const words = getCloudData();

    const wordCloudOptions = {
        colors: ["var(--mainText)"],
        enableTooltip: false,
        deterministic: true,
        fontFamily: "roboto",
        fontSizes: [25, 70],
        fontStyle: "normal",
        fontWeight: "normal",
        padding: 1,
        rotations: 0,
        scale: "sqrt",
        spiral: "rectangular",
        transitionDuration: 2000
    };

    return (
        <>
            <SectionContainer ignoreContainer>
                <div style={{ height: 400, minWidth: 400, maxWidth: 800, margin: '0 auto', paddingTop: 20 }}>
                    <ReactWordcloud words={words} options={wordCloudOptions} />
                </div>
            </SectionContainer>
            <Grid container direction="row">
                <DoughnutChart words={words} isTopFive={true} />
                <DoughnutChart words={words} />
            </Grid>
            <SectionContainer title={getLocalizedString("sentimentAnalysis")} ignoreContainer>
                <div style={{ display: 'flex', justifyContent: 'center', margin: 20 }}>
                    {
                        pollsSelected.map((item, index) => {
                            return (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', marginRight: 20 }}>
                                    <div style={{ width: 20, height: 20, background: pollsSelectedColors[index], marginRight: 10 }} />
                                    <Typography className="whiteText">
                                        {item.name}
                                    </Typography>
                                </div>
                            )
                        })
                    }
                </div>
                <Grid container style={{ paddingTop: 20 }}>
                    {
                        sentimentsData.map((sentiment, index) => {
                            return (
                                <Grid
                                    key={index}
                                    container item xs={4} direction='column' alignItems="center" justify="center"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => handleSentimentClick(index, sentiment.data[0], sentiment.data[1])}
                                >
                                    {sentiment.icon}
                                    <AmountComparison
                                        colors={pollsSelectedColors}
                                        name1={pollsSelected[0].name}
                                        name2={pollsSelected[1].name}
                                        amount1={sentiment.data[0].length}
                                        amount2={sentiment.data[1].length}
                                    />
                                </Grid>
                            )
                        })
                    }
                </Grid>
                <Typography className='whiteText' style={{ fontSize: 20, textAlign: 'center', paddingTop: 30, paddingBottom: 30 }}>
                    {getLocalizedString("clickEachOneForMoreInformation")}
                </Typography>
            </SectionContainer>
            <SectionContainer title={getLocalizedString("allAnswers")} useBigWidth useBigHeight={questionData.length > 5}>
                {
                    questionData.map((question, index) => {
                        return (
                            <Typography key={index} className='whiteText' style={{ fontSize: 20, margin: '5px 0px' }}>
                                {question.RESPUESTA}
                            </Typography>
                        )
                    })
                }
            </SectionContainer>
            {
                Boolean(gridData?.data) &&
                <SentimentDialog
                    open={Boolean(gridData?.data)}
                    type={gridData?.type}
                    data={gridData?.data}
                    path={"pollComparisonSentiments"}
                    handleClose={() => {
                        setGridData(null);
                        forceGridDataUpdate();
                    }}
                />
            }
        </>
    );
}

export default WordsPollData;
